import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Alice Cooper",
    title: "Remote Worker",
    content: "Switching to this provider was the best decision we made! The Internet speed is fantastic, and we’ve had a seamless experience streaming and working from home. Highly recommend for reliable service.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Robert Green",
    title: "Home User",
    content: "The bundled Internet and TV package is perfect for our family. We get all our favorite channels and the Internet speed is excellent. Customer service was incredibly helpful with setting everything up!",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Emma Thompson",
    title: "Business Owner",
    content: "As a small business owner, reliable Internet is crucial, and this provider has never let us down. Our connection is always fast, which has been fantastic for video calls and online transactions.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Chris Martin",
    title: "Residential Customer",
    content: "We recently upgraded to a faster package and it’s been fantastic. No more buffering during movie nights, and everyone in the family can stay connected without any issues! Absolutely thrilled with the speed!",
  },
];

export default testimonials;